import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { MouAcceptance } from '../rob-required/model/mou-acceptance.model';

@Injectable({
    providedIn: 'root'
})
export class MouService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getRobDocument(): Observable<any> {
        return this.get<any>(EndPoints.mou_GetRobDocument);
    }

    signDocument(mouAcceptance: MouAcceptance): Observable<any> {
        return this.post<any>(EndPoints.mou_SignDocument, false, '', {
            mouAcceptance: mouAcceptance
        });
    }
}
